import React from 'react';
import './Footer.css'
const Footer=()=>{
    return(
        <div class="Footer">
      {/* <p class="description"> Keeping the flag of #No1 and in full flow has added an immense deal of coolness here during his journey as a MART</p>*/}
       <div class='container'>
       <div>
           <h1 style={{fontSize:'50px'}}>24/7</h1>  
           <small>Customer Service</small>  
       </div>
     
           <dl >
               <dd><h3>Products</h3></dd>
               <dd><a>Smart Phones</a></dd>
               <dd><a>Laptops</a></dd>
               <dd><a>Headphone</a></dd>
               <dd><a>Earphone</a></dd>
               <dd><a>Earbud</a></dd>
             
           </dl>
           <dl >
               <dd><h4>Connect with us</h4></dd>
               <dd><a>Facebook</a></dd>
               <dd><a>Twitter</a></dd>
               <dd><a>Instagram</a></dd>
           </dl>

           
           <dl >
               <dd><h3>Get to know us</h3></dd>
               <dd><a>About us</a></dd>
               <dd><a>Read Our Blog</a></dd>
               <dd><a>Terms Of Use</a></dd>
               <dd><a>Terms Of Service</a></dd>
               <dd><a>Privacy Policy</a></dd>
           </dl>
         

           
           <dl class="Help">
               <dd><h3>Help</h3></dd>
               <dd><a>Track Orders</a></dd>
               <dd><a>Warranty & Support</a></dd>
               <dd><a>Bulk Orders</a></dd>
               <dd><a>FAQs</a></dd>
               <dd><a>Product Verification</a></dd>
           </dl>
          
           
       </div>
       <footer>&copy; 2021 MART Private Limited. All Rights Reserved</footer>

        </div>
    )
  
}
export default Footer;